// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".a[data-v-32538f91]{fill:#f55858}.b[data-v-32538f91]{fill:#f14242}.c[data-v-32538f91]{fill:#eab599}.d[data-v-32538f91]{fill:#f6caae}.e[data-v-32538f91]{fill:#404040}", ""]);
// Exports
module.exports = exports;
